import {RootState} from '../../rootReducer';

export const getUser = (state: RootState) => state.data.user.user;

export const getIsUpdatingUser = (state: RootState) => state.data.user.isUpdatingUser;

export const getSubscriptionId = (state: RootState) => state.data.user.user.subscriptionId;

export const getUserDirectoryObjectId = (state: RootState) => state.data.user.user.directoryObjectId;

export const getUserImageHash = (state: RootState) => state.data.user.user.imageHash;

export const getUserEmail = (state: RootState) => state.data.user.user.email;

export const getIsDeletingProfileImage = (state: RootState) => state.data.user.isDeletingProfileImage;

export const getIsNew = (state: RootState) => state.data.user.user.isNew;
